import { tryGetNumber } from '@nextiva/analytics-common';
import { getQueryParamSelector } from "../../Routing/state";
import { createSelector } from 'reselect';
var DEFAULT_LIMIT = 25;
export var searchSelector = createSelector(getQueryParamSelector('search'), function (val) {
  return val || '';
});
export var limitSelector = createSelector(getQueryParamSelector('limit'), function (val) {
  return tryGetNumber(val, DEFAULT_LIMIT);
});
export var offsetSelector = createSelector(getQueryParamSelector('offset'), function (val) {
  return tryGetNumber(val, 0);
});